import clsx from 'clsx';
import { ChevronDown, ChevronUp } from 'lucide-react';
import type { Draft, OrderingQ } from '../types';
import styles from '../QuizView.module.css';

type Props = {
  question: OrderingQ;
  draft: Extract<Draft, { format: 'element_order' }>;
  onChange: (d: Extract<Draft, { format: 'element_order' }>) => void;
  disabled: boolean;
  showFeedback: boolean;
};

export function Ordering({ question, draft, onChange, disabled, showFeedback }: Props) {
  const move = (from: number, to: number) => {
    if (to < 0 || to >= draft.order.length) return;
    const next = draft.order.slice();
    [next[from], next[to]] = [next[to], next[from]];
    onChange({ format: 'element_order', order: next });
  };

  return (
    <div className={styles.ordering}>
      {question.instruction && (
        <p className={styles.qInstruction}>{question.instruction}</p>
      )}

      <ol className={styles.sortList}>
        {draft.order.map((elIdx, pos) => {
          const correctHere = showFeedback && elIdx === question.correct_order[pos];
          const wrongHere = showFeedback && !correctHere;
          return (
            <li
              key={elIdx}
              className={clsx(
                styles.sortRow,
                correctHere && styles.slotCorrect,
                wrongHere && styles.slotWrong
              )}
            >
              <span className={styles.sortIndex}>{pos + 1}</span>
              <span className={styles.sortText}>{question.elements[elIdx]}</span>
              <div className={styles.sortBtns}>
                <button
                  type="button"
                  onClick={() => move(pos, pos - 1)}
                  disabled={disabled || pos === 0}
                  className={styles.sortBtn}
                  aria-label="Mover hacia arriba"
                >
                  <ChevronUp size={16} />
                </button>
                <button
                  type="button"
                  onClick={() => move(pos, pos + 1)}
                  disabled={disabled || pos === draft.order.length - 1}
                  className={styles.sortBtn}
                  aria-label="Mover hacia abajo"
                >
                  <ChevronDown size={16} />
                </button>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
